import {useState} from 'react';
import {Container, Navbar, Nav, NavDropdown, Dropdown, Offcanvas} from 'react-bootstrap';
import {Link, NavLink} from 'react-router-dom';
import Skeleton from 'react-loading-skeleton';
import useWindowSize from '../../hooks/useWindowSize';
import UserSidebarMenu from '../../components/user/UserSidebarMenu';
import MegaMenu from './mega-menu/MegaMenu';
import {useModal} from '../../context/ModalContext';
import {useAuth} from '../../context/AuthContext';
import UserMenu from './user-menu/UserMenu';
import {useMixContext} from '../../context/MixContext';
import Classes from './NavBar.module.scss';

//== Import icons
import userIcon from '../../assets/icons/logUser.svg';
import MobileUserIcon from '../../assets/icons/logInMobile.svg';
import createIconMobile from '../../assets/icons/createMobile.svg';
import MenuCaretIcon from '../../assets/icons/ArrowBottom.svg';
import UploadIcon from '../../assets/icons/upload.svg';
import CreateIcon from '../../assets/icons/create.svg';
import UserAvatar from '../../assets/icons/logUser.svg';
import Logo from '../../assets/icons/brandLogo.svg';
import HamMenu from '../../assets/icons/menu.svg';
import CloseMenu from '../../assets/icons/menuClose.svg';


const NavBar = () => {
    const [showMenuIcon, setShowMenuIcon] = useState(false);
    const {handleJoinFormShow} = useModal();
    const {setShowLogin} = useMixContext();
    const {width} = useWindowSize();
    const {storedUserData, getIsLoggedIn} = useAuth();
    const isAuth = getIsLoggedIn();

    //== States
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    return (
        <Container>
            <Navbar expand={'xl'} className={`${Classes.navBar} pt-2 pt-md-0 pb-md-1 pb-xl-3`}>
                <Link
                    to={'/'}
                    className={`${Classes.navbarBrand} navbar-brand`}
                >
                    <img
                        src={Logo}
                        alt="Gifbuz"
                        className={'img-fluid'}
                        onLoad={() => (
                            <Skeleton
                                style={{maxWidth: '155px'}}
                                width={'100%'}
                                height={45}
                            />
                        )}
                    />
                </Link>
                <div className={'ms-auto d-flex align-items-center'}>
                    <div className="d-none d-xl-block">
                        <Nav
                            className={`${Classes.navMenu} align-items-center`}
                            style={{marginRight: `${isAuth ? `${width >= 1400 ? '73' : '70'}` : `${width >= 1400 ? '100' : '75'}`}px`}}
                        >
                            <Nav.Item className={Classes.navItem}>
                                <NavLink
                                    to={'/category/stickers'}
                                    state={{catName: "Stickers"}}
                                >
                                    Stickers
                                </NavLink>
                            </Nav.Item>
                            <Nav.Item className={Classes.navItem}>
                                <NavLink
                                    to={'/popular'}
                                >
                                    Popular
                                </NavLink>
                            </Nav.Item>
                            <Nav.Item className={Classes.navItem}>
                                <NavLink
                                    to={'/all-artist'}
                                >
                                    Artists
                                </NavLink>
                            </Nav.Item>
                            <NavDropdown
                                title={<>Categories <img src={MenuCaretIcon} alt={'Categories'}/></>}
                                id="collasible-nav-dropdown-desktop"
                                className={`${Classes.navItem} ${Classes.catBtn} megaMenuDrop`}
                            >
                                <MegaMenu/>
                            </NavDropdown>
                        </Nav>
                    </div>
                    <div className={`${Classes.uploadCreateLink} d-flex align-items-center`}>
                        <div className="d-none d-lg-block">
                            <div className="d-flex align-items-center">
                                <Link to={'/upload'} className={`${Classes.dLink}`}>
                                    <img src={UploadIcon} alt="Upload" className={'me-3'}/>
                                    Upload
                                </Link>
                                <Link to={'/create'} className={`${Classes.dLink} me-xl-4 me-xxl-5`}>
                                    <img src={CreateIcon} alt="Create" className={'me-3'}/>
                                    Create
                                </Link>

                                {isAuth ? (
                                    <>
                                        <Dropdown
                                            className={Classes.userDropdownWrap}
                                            align={'end'}
                                        >
                                            <Dropdown.Toggle
                                                id="user-dropdown-menu"
                                                className={`${Classes.loginBtn} g-btn d-flex align-items-center text-lowercase`}
                                            >
                                                <div
                                                    className={`${Classes.userDisplayName} text-truncate text-capitalize`}>
                                                    {storedUserData?.displayName ? storedUserData?.displayName : storedUserData?.userName}
                                                </div>
                                                <div className={Classes.userIcon}>
                                                    <img
                                                        src={storedUserData?.profilePic ? `${process.env.REACT_APP_MEDIA_SERVER}/${storedUserData?.profilePic}` : userIcon}
                                                        alt={storedUserData?.userName}
                                                        width={34}
                                                        height={34}
                                                        className={'rounded-circle'}
                                                    />
                                                </div>
                                            </Dropdown.Toggle>
                                            <UserMenu/>
                                        </Dropdown>
                                    </>
                                ) : (
                                    <button
                                        className={`${Classes.loginBtn} g-btn d-inline-flex align-items-center`}
                                        onClick={() => {
                                            handleJoinFormShow();
                                            setShowLogin(false);
                                        }}
                                    >
                                        Log in
                                        <span className={Classes.userIcon}>
                                            <img src={UserAvatar} alt="User Avatar" className={'img-fluid'}/>
                                        </span>
                                    </button>)}
                            </div>
                        </div>
                        <>
                            <div className="d-flex align-items-center">
                                <div className="d-block d-lg-none">
                                    <div className={`${Classes.mobileNavbar} d-flex align-items-center`}>
                                        <Link to={'/create'} className={Classes.mLink}>
                                            <img src={createIconMobile} alt="Create"/>
                                        </Link>
                                        {isAuth ? (
                                            <>
                                                <button
                                                    onClick={handleShow}
                                                    className={Classes.userDropdownBtnMobile}
                                                >
                                                    <img
                                                        src={storedUserData?.profilePic ? `${process.env.REACT_APP_MEDIA_SERVER}/${storedUserData?.profilePic}` : userIcon}
                                                        alt={storedUserData?.userName}
                                                        width={30}
                                                        height={30}
                                                    />
                                                </button>
                                                <Offcanvas
                                                    show={show}
                                                    onHide={handleClose}
                                                    placement={'end'}
                                                    scroll={true}
                                                >
                                                    <Offcanvas.Header className={Classes.offCanvasHeader}>
                                                        <div className={'d-flex align-items-center'}>
                                                            <img
                                                                src={storedUserData?.profilePic ? `${process.env.REACT_APP_MEDIA_SERVER}/${storedUserData?.profilePic}` : userIcon}
                                                                alt={storedUserData?.userName}
                                                                width={58}
                                                                height={58}
                                                                className={`${Classes.userThumbnail} me-2`}
                                                            />
                                                            <div className={Classes.offCanvasMenuUser}>
                                                                <Link
                                                                    to={`/artist/${storedUserData?.userName}`}
                                                                    className={'text-truncate'}
                                                                    onClick={handleClose}
                                                                >
                                                                    {storedUserData?.displayName || storedUserData?.userName}
                                                                </Link>
                                                                <div
                                                                    className={`${Classes.usernameWrap} d-flex align-items-center`}>
                                                                    <span
                                                                        className={'text-truncate'}>@{storedUserData?.userName}</span>
                                                                    {storedUserData?.emailVerified && (
                                                                        <svg xmlns="http://www.w3.org/2000/svg"
                                                                             width="17" height="17"
                                                                             viewBox="0 0 17 17"
                                                                             className={`ms-1 ${Classes.userNameClampSvg}`}>
                                                                            <g transform="translate(-0.165 0.137)">
                                                                                <path
                                                                                    d="M6.639,2.461a2.333,2.333,0,0,1,3.721,0l.017.023a2.333,2.333,0,0,0,1.893.926h.055a2.333,2.333,0,0,1,2.3,2.869l-.046.2a2.333,2.333,0,0,0,.448,1.993l.135.169a2.333,2.333,0,0,1-.818,3.562l-.136.065a2.333,2.333,0,0,0-1.279,1.629l-.024.116a2.333,2.333,0,0,1-3.345,1.6h0a2.333,2.333,0,0,0-2.124,0h0a2.333,2.333,0,0,1-3.345-1.6l-.024-.116a2.333,2.333,0,0,0-1.279-1.629L2.653,12.2a2.333,2.333,0,0,1-.818-3.562l.135-.169a2.333,2.333,0,0,0,.448-1.993l-.046-.2a2.333,2.333,0,0,1,2.3-2.869h.055a2.333,2.333,0,0,0,1.893-.926Z"
                                                                                    transform="translate(0.165 -0.137)"
                                                                                    fill="#1EE3A7"/>
                                                                                <path
                                                                                    d="M5.911,9.479,4.173,7.741a.483.483,0,0,1,.683-.683l1.4,1.394L9.586,5.122a.483.483,0,0,1,.683.683L6.594,9.479a.482.482,0,0,1-.683,0Z"
                                                                                    transform="translate(1.422 1.313)"
                                                                                    fill="#fff" stroke="#fff"
                                                                                    strokeWidth="0.6"/>
                                                                            </g>
                                                                        </svg>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Offcanvas.Header>
                                                    <Offcanvas.Body className={'pt-2'}>
                                                        <UserSidebarMenu onClick={handleClose}/>
                                                    </Offcanvas.Body>
                                                </Offcanvas>
                                            </>
                                        ) : (
                                            <button
                                                onClick={() => {
                                                    handleJoinFormShow();
                                                    setShowLogin(false);
                                                }}
                                                className={Classes.mLink}
                                            >
                                                <img src={MobileUserIcon} alt="User login"/>
                                            </button>
                                        )}
                                    </div>
                                </div>
                                <div className="d-block d-xl-none">
                                    <NavDropdown
                                        title={
                                            showMenuIcon ?
                                                <img src={CloseMenu} alt="Close"/> :
                                                <img src={HamMenu} alt="Menu"/>
                                        }
                                        align="end"
                                        id="collasible-nav-dropdown-mobile"
                                        className={`${Classes.navItem} ${Classes.megaMenuBtn} megaMenuDrop`}
                                        onToggle={() => setShowMenuIcon(!showMenuIcon)}
                                    >
                                        <MegaMenu/>
                                    </NavDropdown>
                                </div>
                            </div>
                        </>
                    </div>
                </div>
            </Navbar>
        </Container>
    );
};

export default NavBar;